import { ARROW_ICON, HeaderNavigation } from '@components/shared/header/header.state';
import style from './nav-item.module.scss';
import Link from 'next/link';
import { ReactSVG } from 'react-svg';
import { useRouter } from 'next/router';
import { Themes } from '@layouts/main-layout/themes.enum';
import { Dispatch, SetStateAction } from 'react';
import { useTranslations } from 'next-intl';
import ArrowIcon from 'public/assets/icons/icn-arrow.svg';


type NavItemProps = {
  viewingLink: string;
  setViewingLink: Dispatch<SetStateAction<string>>;
  item: HeaderNavigation;
  theme?: Themes;
};

export const NavItem = ({
  item: { name, link, preview, newTab, activePaths },
  viewingLink,
  setViewingLink,
  theme = Themes.Default,
}: NavItemProps) => {
  const { pathname } = useRouter();
  const t = useTranslations();

  const conditionalStyles = (activePaths || [link]).some(path => pathname.startsWith(path))
    ? style.item__link_active
    : '';
  const iconConditionalStyles = viewingLink === link ? style.item__icon_active : '';
  return (
    <>
      <div
        onMouseEnter={() => setViewingLink(link)}
        onMouseLeave={() => setViewingLink('')}
        className={`${style.item} ${style[theme]}`}
      >
        <Link
          href={link}
          target={newTab ? '_blank' : '_self'}
          rel={newTab ? 'noopener noreferrer' : undefined}
          onClick={() => setViewingLink('')}
          className={`${style.item__link} ${conditionalStyles}`}
        >
          {t(name)}
        </Link>
        {preview ? (
          <ArrowIcon className={`${style.item__icon} ${style[theme]} ${iconConditionalStyles}`} />
        ) : (
          ''
        )}
        {viewingLink === link ? preview?.(theme, setViewingLink) : ''}
      </div>
    </>
  );
};
